// Per-device-type field rules for devices created automatically from an
// order (SEC-216). Mirrors the v-if regexes on the manual create form
// (src/views/admin/create/alarm.vue) — keep the two in sync.

const HIDE_IMEI = /(SRT334)|(TWIG Beacon)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)/;
const HIDE_PHONE = /(SRT334)|(TWIG Beacon)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX (?!Hub))|(SecurDesktop)/;
const HIDE_SERIAL = /(Avigilon Alta Compact Dome 5MP)|(SecurDesktop)/;
const HIDE_OPERATOR = /(SRT334)|(SRT330)|(SRT430)|(TWIG Beacon)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX (?!Hub))|(SecurDesktop)/;
const HIDE_INVENTORY = /(SRT334)|(TWIG Beacon)|(Anchor Beacon)|(Avigilon Alta Compact Dome 5MP)|(AJAX)|(SecurDesktop)/;

export const SIM_OPERATORS = ["Telia", "Telia DCP", "Telenor", "Tele2", "Kundens Simkort"];

// Which of the modal's fields apply to a device type. `inventory_number`
// is optional even when shown (same as the create form).
export function deviceFieldVisibility(type) {
  const t = type || "";
  return {
    imei_number: !HIDE_IMEI.test(t),
    phone: !HIDE_PHONE.test(t),
    modelnumber: !HIDE_SERIAL.test(t),
    operator: !HIDE_OPERATOR.test(t),
    inventory_number: !HIDE_INVENTORY.test(t),
  };
}

// A device created from an order counts as incomplete until every field the
// create form would have required for its type is filled in. Used to flag
// devices in the business view and to resume the details modal (REQ-04).
export function isOrderDeviceIncomplete(alarm) {
  if (!alarm || !alarm.source_order || !alarm.source_order.order_id) return false;
  const visible = deviceFieldVisibility(alarm.type);
  const missing = (field) => visible[field] && !(alarm[field] && String(alarm[field]).trim());
  return missing("imei_number") || missing("phone") || missing("modelnumber") || missing("operator");
}
